import { render, staticRenderFns } from "./FlickingPluginView.vue?vue&type=template&id=5e81e036&scoped=true"
import script from "./FlickingPluginView.vue?vue&type=script&lang=js"
export * from "./FlickingPluginView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e81e036",
  null
  
)

export default component.exports